import React from "react";
import svg10 from "../../assets/svg/svg10.svg";
import svg46 from "../../assets/svg/svg46.svg";
import svg47 from "../../assets/svg/svg47.svg";
import svg48 from "../../assets/svg/svg48.svg";
import svg49 from "../../assets/svg/svg49.svg";
import { useNavigate } from "react-router-dom";

function BusinessType({ setActive }) {
  const items = [
    {
      title: "Contractors",
      svg: svg46,
      desc: "Pay casuals and track project expenses from one dashboard.",
    },
    {
      title: "Event Organizers",
      svg: svg47,
      desc: "Disburse staff and vendor payments before or after events.",
    },
    {
      title: "SMEs & MSMEs",
      svg: svg48,
      desc: "Automate daily operations, payrolls, and supplier settlements.",
    },
    {
      title: "Enterprises",
      svg: svg49,
      desc: "Integrate Ndovu Pay with your ERP for large-scale financial control.",
    },
  ];
  const navigate = useNavigate();
 

  const handleRegister = async () => {
    window.location.href="https://app.ndovupay.org/#/registration"
  };

  const handleInquire = () => {
    if (setActive) {
      setActive('contact');
    }
  };
  return (
    <div className="flex lg:flex-row flex-col justify-between gap-[2rem] lg:gap-[3rem]">
      <div className="flex flex-col w-full lg:max-w-[40%]">
        <div className="text-[#0F172A] text-[1.75rem] md:text-[2.25rem] font-[600] leading-[2.625rem] max-w-full lg:max-w-[27rem]">
          Built for Every Business Type
        </div>
        <div className="mt-[.75rem] text-[#7A7493] text-[1rem] font-[400] leading-[1.625rem] max-w-full lg:max-w-[23.34938rem]">
          From startups to enterprises, Ndovu Pay powers growth across retail,
          logistics, SaaS, and financial services.
        </div>

        <div className="mt-[1.5rem] flex items-center gap-[.62rem] flex-wrap">
          <button className="cstm-btn-2 !min-w-[12.625rem] !w-auto" onClick={handleRegister}>
            Create Account <img src={svg10} alt="svg10" />
          </button>
          <button className="cstm-btn !min-w-[10rem] !w-auto" onClick={handleInquire}>Inquire</button>
        </div>
      </div>

      <div className="flex flex-shrink flex-wrap justify-center gap-[1.5rem] flex-1">
        {items &&
          items?.map((item, index) => (
            <div key={index} className="p-[1.5rem] rounded-[1.25rem] bg-white shadow-[0_2px_10px_0_rgba(35,31,32,0.10)] w-full sm:w-[calc(50%-0.75rem)] lg:w-[calc(50%-0.75rem)] max-w-[18rem]">
              <img src={item?.svg} alt={item?.svg} className="w-full h-auto object-contain max-h-[10rem]"/>
              <div className="mt-[.5rem] text-[#1E191B] text-[.875rem] font-[500] leading-[1.5rem]">
                {item?.title}
              </div>
              <div className="mt-[.5rem] text-[#7A7493] text-[.875rem] font-[400] leading-[1.25rem] font-interSans max-w-full">
                {item?.desc}
              </div>
            </div>
          ))}
      </div>
    </div>
  );
}

export default BusinessType;
